import * as types from "./actionTypes";
import initialState from "reducers/initialState";

const exp = (state = initialState.dealerBranding, action) => {
  switch (action.type) {
    case types.APPLICATION_THEME_LOAD_SUCCEEDED:
      return loadApplicationThemeSucceeded(state, action);
    case types.APPLICATION_THEME_LOAD_FAILED:
      return loadApplicationThemeFailed(state, action);

    default:
      return state;
  }
};

const loadApplicationThemeSucceeded = state => {
  return {
    ...state,
    theme: {
      loading: false,
      loaded: true
    }
  };
};

const loadApplicationThemeFailed = state => {
  return {
    ...state,
    theme: {
      loading: false,
      loaded: false
    }
  };
};

export default exp;
